import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GonvarriImportEntriesDialogComponent } from '../../components/gonvarri-import-entries-dialog/gonvarri-import-entries-dialog.component';
import {FeaturesConfigModule, I18nModule, provideConfig} from "@spartacus/core";
import {gonvarriImportEntriesLayoutConfig} from "../../layouts/gonvarri-import-entries-layout.config";
import {
    FileUploadModule,
    FormErrorsModule,
    IconModule,
    KeyboardFocusModule,
    MessageComponentModule, SpinnerModule
} from "@spartacus/storefront";
import { GonvarriImportToNewSavedCartFormComponent } from '../../components/gonvarri-import-to-new-saved-cart-form/gonvarri-import-to-new-saved-cart-form.component';
import {ReactiveFormsModule} from "@angular/forms";
import { GonvarriImportEntriesFormComponent } from '../../components/gonvarri-import-entries-form/gonvarri-import-entries-form.component';
import { GonvarriImportEntriesSummaryComponent } from '../../components/gonvarri-import-entries-summary/gonvarri-import-entries-summary.component';

@NgModule({
  declarations: [
    GonvarriImportEntriesDialogComponent,
    GonvarriImportToNewSavedCartFormComponent,
    GonvarriImportEntriesFormComponent,
    GonvarriImportEntriesSummaryComponent
  ],
    imports: [
        CommonModule,
        KeyboardFocusModule,
        I18nModule,
        FeaturesConfigModule,
        IconModule,
        MessageComponentModule,
        ReactiveFormsModule,
        FileUploadModule,
        FormErrorsModule,
        SpinnerModule
    ],
  providers: [
    provideConfig(gonvarriImportEntriesLayoutConfig)
  ]
})
export class GonvarriImportEntriesDialogModule { }
